<template>
	<div id="org_list">
		<van-tabs v-model="active">
			<van-tab title="上下级组织">
				<items v-for="cell in orgs" :model="cell"></items>
			</van-tab>
			<van-tab title="加入组织">
				<van-search v-model="title" placeholder="根据组织名搜索" show-action shape="round" @search="onSearch">
					<div slot="action" @click="onSearch">搜索</div>
				</van-search>
				<div style="display: flex;height: 45px;background-color: gainsboro">
					<button class="select" @click="selectType">
				{{type}}
			</button>
					<button class="select" @click="selectArea">
				{{area}}
			</button>
				</div>
				<van-pull-refresh v-model="isLoading" @refresh="onRefresh">
					<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad" :error.sync="error" error-text="请求失败，点击重新加载">
						<div @click="go(model.id)" v-for="model in list" style="display: flex;height: auto;background-color: white;border: 1px solid #e8e8e8;margin-bottom: 5px;">
							<div style="margin: auto;height: 120px;width: 120px;border-right: 1px solid #e8e8e8;text-align: center;">
								<img :src="model.organizationSeal|addPath" style="height: auto;width: auto;max-height: 80%; max-width: 80%; margin: 10%;" />
							</div>
							<div style="flex: 2;">
								<p style="color: black;font-size: 16px;font-weight: 600;">{{model.orgName}}</p>
								<p><span style="color: black;">服务类型</span> | {{model.serviceType}}</p>
								<p><span style="color: black;">地区 </span>| {{model.regulatorArea}}</p>
								<p><span style="color: black;">详细地址 </span>| {{model.address}}</p>
							</div>
						</div>
					</van-list>
				</van-pull-refresh>
				<van-popup v-model="show2" position="bottom" style="top:50%">
					<van-area :area-list="areaList" @confirm='confirm' @cancel='cancel' :visible-item-count="7" />
				</van-popup>
				<van-popup v-model="show3" position="bottom" style="top:50%">
					<van-picker show-toolbar :columns="columns" :visible-item-count="7" @cancel="onCancel" @confirm="onConfirm" />
				</van-popup>
			</van-tab>
		</van-tabs>
	</div>
</template>

<script>
	import { Cell, CellGroup, Dialog, Pagination, NavBar, Popup, Search, Loading, Toast, Icon, Area, Picker, List, PullRefresh, Tab, Tabs } from 'vant';
	import axios from 'axios';
	import store from '@/store/store.js';
	import global from '@/api/global';
	import { htmlspecialchars_decode, formatDate } from '@/js/common.js';
	import container from '@/view/organization/template/tree';
	import Vue from 'vue';
	import VueCookies from 'vue-cookies';
	import areaList from '@/js/area.js';
	Vue.use(VueCookies);
	export default {
		name: "organization_list",
		filters: {
			formatDate(time) {
				return formatDate(time, 'yyyy-MM-dd');
			},
			addPath(path) {
				return global.resoursePhoto + "/" + path;
			}
		},
		components: {
			[Cell.name]: Cell,
			[CellGroup.name]: CellGroup,
			[Dialog.name]: Dialog,
			[Pagination.name]: Pagination,
			[NavBar.name]: NavBar,
			[Popup.name]: Popup,
			[axios.name]: axios,
			[Search.name]: Search,
			[Loading.name]: Loading,
			[Toast.name]: Toast,
			[Icon.name]: Icon,
			'items': container,
			[Area.name]: Area,
			[Picker.name]: Picker,
			[List.name]: List,
			[PullRefresh.name]: PullRefresh,
			[Tab.name]: Tab,
			[Tabs.name]: Tabs
		},
		data() {
			return {
				active: 0,
				isLoading: false,
				error: false,
				loading: false,
				finished: false,
				count: 0,
				areaList,
				list: [],
				title: "",
				page: 1,
				limit: 8,
				show: false,
				show2: false,
				show3: false,
				area: "选择地区",
				areaCode: "",
				columns: [],
				type: "选择服务",
				volunteerCorps: "",
				orgs: []
			}
		},
		created: function() {
			this.getType();
			this.getOid();
			this.$store.commit("show", "organization_list");
		},
		beforeRouteLeave(to, from, next) {
			if(to.name === 'organization_details') {
				next();
			} else {
				this.$store.commit("show", ",");
				next();
			}
		},
		activated() {
			this.$store.commit("show", "organization_list");
		},
		methods: {
			getOid() { //获取
				Toast.loading({
					mask: true,
					message: '加载中...',
					duration: 0
				});
				axios({
					method: 'get',
					url: global.baseURL + 'appsite/orgform/selectByTree',
					params: {}
				}).then((resp) => {
					var list = resp.data;
					var b = {};
					var array = [];
					var oid = 0;
					for(var i = 0; i < list.length; i++) {
						b[list[i].id] = {
							label: list[i].orgName,
							id: list[i].id,
							content: list[i],
							children: []
						};
					}
					for(var id in b) {
						//console.log("属性：" + id + ",值：" + b[id]);
						if(b[id].content.oid!=0){
							//console.log(b[id].content.oid)
							b[b[id].content.oid].children.push(b[id]);
						}
					}
					var c = [];
					for(var id in b) {
						//console.log("属性：" + id + ",值：" + b[id]);
						if(b[id].content.oid==0){
							//console.log(b[id].content.oid)
							//b[b[id].content.oid].children.push(b[id]);
							c.push(b[id]);
						}
					}
					console.log(c);
					this.orgs = c;
					/*					for(var i = 0; i < list.length; i++) {
											if(list[i].oid == 0) {
												b.push({
													label: list[i].orgName,
													id: list[i].id,
													content: list[i],
													children: array
												})
												array = [];
											} else {
												if(oid != 0 && list[i].id == oid) {
													var a = {
														label: list[i].orgName,
														id: list[i].id,
														content: list[i],
														children: array
													}
													array = [];
													array.push(a);
												} else {
													array.push({
														label: list[i].orgName,
														content: list[i],
														id: list[i].id
													});
												}
												oid = list[i].oid;
											}
										}
										this.orgs = b;
										console.log(b);*/
					Toast.clear();
				}).catch(resp => {
					Toast.clear();
					console.log(resp)
					Toast.fail('请求失败');
				});
			},
			go(id) {
				this.$router.push({
					path: '/organization_details', //跳转的路径
					query: { //路由传参时push和query搭配使用 ，作用时传递参数
						id: id
					}
				});
			},
			//获取服务类型
			getType() {
				axios({
					method: 'get',
					url: global.baseURL + 'appsite/dictionary/selectList?type=type_zhfy'
				}).then((resp) => {
					var columns = resp.data.list;
					this.columns.push("全部");
					for(var i = 0; i < columns.length; i++) {
						this.columns.push(columns[i].name);
					}
				}).catch(resp => {
					Toast.fail('请求失败');
				});
			},
			onCancel() {
				this.show3 = false;
			},
			onConfirm(value, index) {
				this.type = value;
				this.show3 = false;
			},
			cancel() {
				this.show2 = false;
			},
			//选择地区
			confirm(e) {
				if(e[1] == null) {
					this.area = e[0].name;
					this.show2 = false;
					this.volunteerCorps = e[0].code;
				} else if(e[2] == null) {
					this.area = e[0].name + "/" + e[1].name;
					this.show2 = false;
					this.volunteerCorps = e[1].code;
				} else {
					this.area = e[0].name + "/" + e[1].name + "/" + e[2].name;
					this.show2 = false;
					this.volunteerCorps = e[2].code;
				}
			},
			selectArea() {
				this.show2 = true;
			},
			selectType() {
				this.show3 = true;
			},
			onRefresh() {
				this.list = [];
				this.page = 1;
				Toast.loading({
					mask: true,
					message: '加载中...',
					duration: 0
				});
				var type;
				if(this.type == "选择服务" || this.type == "全部") {
					type = null;
				} else {
					type = this.type;
				}
				if(this.volunteerCorps == "100000") {
					this.volunteerCorps = "";
				}
				axios({
					method: 'get',
					url: global.baseURL + 'appsite/orgform/selectList',
					params: {
						"orgName": this.title,
						"pageSize": this.limit,
						"volunteerCorps": this.volunteerCorps.replace(/(0+)$/g, ""), //尾部除零
						"serviceType": type,
						"pageNum": this.page
					}
				}).then((resp) => {
					this.list = resp.data.data.data;
					this.count = resp.data.data.count;
					this.page++;
					this.isLoading = false;
					this.finished = false;
					this.error = false;
					this.loading = false;
					if(Math.ceil(this.count / this.limit) < this.page) {
						this.finished = true;
					}
					Toast.clear();
				}).catch(resp => {
					Toast.clear();
					Toast.fail('请求失败');
				});
			},
			onLoad() {
				Toast.loading({
					mask: true,
					message: '加载中...',
					duration: 0
				});
				var type;
				if(this.type == "选择服务" || this.type == "全部") {
					type = null;
				} else {
					type = this.type;
				}
				if(this.volunteerCorps == "100000") {
					this.volunteerCorps = "";
				}
				axios({
					method: 'get',
					url: global.baseURL + 'appsite/orgform/selectList',
					params: {
						"orgName": this.title,
						"pageSize": this.limit,
						"volunteerCorps": this.volunteerCorps.replace(/(0+)$/g, ""), //尾部除零
						"serviceType": type,
						"pageNum": this.page
					}
				}).then((resp) => {
					for(var i = 0; i < resp.data.data.data.length; i++) {
						this.list.push(resp.data.data.data[i]);
					}
					this.count = resp.data.data.count;
					this.isLoading = false;
					this.loading = false;
					this.page++;
					if(Math.ceil(this.count / this.limit) < this.page) {
						this.finished = true;
					}
					Toast.clear();
				}).catch(resp => {
					Toast.clear();
					Toast.fail('请求失败');
				});
			},
			onSearch() {
				this.onRefresh();
			},
			ClickRight() {
				this.show = !this.show;
			}
		}
	}
</script>

<style>
	#org_list .select {
		flex: 1;
		text-align: center;
		border: 0px;
		background-color: #f1f1f1;
	}
	
	#org_list .select:active {
		flex: 1;
		text-align: center;
		border: 0px;
		background-color: grey;
		color: white;
	}
	
	#org_list p {
		font-size: 12px;
		margin: 10px;
		color: gray;
	}
	
	#org_list .van-loading--spinner {
		z-index: 1000;
		color: rgb(201, 201, 201);
		position: absolute;
		top: 50%;
		left: 45%;
	}
	
	#org_list .van-nav-bar__right {
		top: 14px;
		background-repeat: no-repeat;
		background-size: 100% 100%;
		background-image: url(../../image/gdd.png);
		height: 20px;
		width: 20px;
	}
	
	#org_list .van-nav-bar__text {
		color: #656464;
		font-size: 16px;
	}
	
	#org_list .van-cell {
		padding-left: 5px;
	}
	
	#org_list .pop_span {
		margin: 9px 14px;
	}
	
	#org_list .pop {
		height: 40px;
		margin: 0px;
		background-color: #eaeaea;
		color: #656464;
		border-top: 1px solid white;
	}
	
	#org_list .van-hairline--bottom {
		background-repeat: no-repeat;
		background-size: 100% 100%;
		background-image: none;
		background-color: #eaeaea;
	}
	
	#org_list .van-popup {
		top: 92px;
	}
	
	#org_list .van-cell span {
		margin: 6px;
		display: block;
	}
	
	#org_list .van-cell__right-icon {
		margin: auto;
	}
	
	#org_list .van-cell__left-icon {
		height: 80px;
		width: 120px;
	}
	
	#org_list .van-cell__left-icon>img {
		height: 100%;
		width: 100%;
	}
	
	#org_list .van-cell__value--alone {
		text-align: center;
	}
	
	#org_list .van-cell__label {
		margin-left: 6px;
	}
</style>